





































































































import { ValidationObserver } from 'vee-validate'
import { Component, Mixins } from 'vue-property-decorator'

import ModelSetter from "../../../Mixins/ModelSetter";
import ResetPasswordModal from "../../../components/Auth/ResetPasswordModal.vue";
import Icon from '../../../components/Icon/Icon.vue'
import PasswordInput from '../../../components/Pi/fields/PasswordInput/PasswordInput.vue';
import TextInput from '../../../components/Pi/fields/TextInput/TextInput.vue';
import { login, PASSWORD_MIN_SYMBOLS } from "../../../logic/auth/logic";
import SvgLogin from '../components/SvgLogin.vue'
import VuChangeApi from '../components/VuChangeApi.vue'

const TGWIDGET_SELECTOR = "tgLogin"

@Component({
  components: {
    ResetPasswordModal,
    TextInput,
    PasswordInput,
    Icon,
    VuChangeApi,
    ValidationObserver,
    SvgLogin,
  },
  data() {
    return {
      TGWIDGET_SELECTOR,
      PASSWORD_MIN_SYMBOLS
    }
  }
})
export default class Login extends Mixins(ModelSetter) {
  loginForm = {
    login: '',
    password: '',
  }

  isLoading = false

  isSetResetPassModalOpen = false

  get showChangeApi(): boolean {
    return this.$route.name === 'login_admin'
  }

  get domainBaseUrl(): string {
    return window.location.origin
  }

  get botAuthLink():string {
    return this.$store.state.AdminTemplate.applicationConfig.meta.login.botAuthLink
  }

  get applicationLoginPageLogo():string {
    return this.$store.state.AdminTemplate.applicationConfig.meta.loginPageLogo
  }

  precheckAuth(invalid: boolean) {
    if (!invalid) {
      this.auth()
    }
  }

  auth(): void {
    this.isLoading = true

    login(this.loginForm.login, this.loginForm.password, this.$store)
      .then(res => {
        if (res) {
          this.$router.replace('/')
        }
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  mounted(): void {
    const tgLoginWidget: HTMLScriptElement = document.createElement('script')
    tgLoginWidget.setAttribute('src', 'https://telegram.org/js/telegram-widget.js?7')
    tgLoginWidget.setAttribute('async', 'true')
    tgLoginWidget.dataset.telegramLogin = this.$store.state.AdminTemplate.applicationConfig.meta.login.loginWidget.botLogin
    tgLoginWidget.dataset.authUrl = `${ this.domainBaseUrl }/${ this.$store.state.AdminTemplate.applicationConfig.meta.login.loginWidget.tgWidgetAuthLink }`
    tgLoginWidget.dataset.size = 'large'

    const targetEl: HTMLElement | null = document.querySelector(`#${ TGWIDGET_SELECTOR }`)
    if (targetEl) {
      targetEl.append(tgLoginWidget)
    }
  }
}
